import React, { useState } from "react";
import { createHttpClient } from "../../api/http";
import { serviceUrls } from "../../config/serviceUrls";
import { Layout } from "../../components/layout/Layout";
import { PageHeader } from "../../components/layout/PageHeader";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/Card";
import { Button } from "../../components/ui/Button";

const TUTOR_BASE = import.meta.env.VITE_AI_TUTOR_BASE_URL || serviceUrls.gateway;
const client = createHttpClient(TUTOR_BASE);
const PREFIX = TUTOR_BASE.includes("ai-tutor") ? "/tutor" : "/v1/tutor";

export default function ScenarioClassroomPage() {
  const [code, setCode] = useState("");
  const [msg, setMsg] = useState<string | null>(null);

  const join = async () => {
    setMsg(null);
    try {
      await client.post(`${PREFIX}/scenario/classroom/join`, {
        session_code: code.trim().toUpperCase(),
        role: "observer",
      });
      setMsg("Joined. Your teacher can rotate the active speaker.");
    } catch (e: unknown) {
      setMsg(e instanceof Error ? e.message : "Join failed");
    }
  };

  return (
    <Layout>
      <PageHeader title="Scenario classroom" subtitle="Join a teacher-led session with a session code." />
      <div className="max-w-md mx-auto px-4 py-8">
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Join with code</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <input
              className="w-full px-3 py-2 rounded-lg border border-slate-200 uppercase"
              placeholder="ABCD1234"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            <Button onClick={() => void join()}>Join session</Button>
            {msg && <p className="text-sm text-slate-600">{msg}</p>}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
